module.exports = __webpack_public_path__ + "img/desmarcador.04a8e233.svg";